import { render, staticRenderFns } from "./UserConfig.vue?vue&type=template&id=6966bf91&scoped=true&"
import script from "./UserConfig.vue?vue&type=script&lang=js&"
export * from "./UserConfig.vue?vue&type=script&lang=js&"
import style0 from "./UserConfig.vue?vue&type=style&index=0&id=6966bf91&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6966bf91",
  null
  
)

export default component.exports